import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { Artist, artistKeys } from "features/reviewable";
import { shopDataQueryKey } from "./queryKeys";
import { ShopDataResp } from "../types";

type ArtistShopUpdateResponse = {
  shopConfig: ShopDataResp;
  artist: Artist;
};

type PutArtistShopParams = {
  artistId: string;
  shopBuilderEnabled: boolean;
  shopOwnerUserId: string;
};

const putArtistShop = (
  params: PutArtistShopParams,
): Promise<ArtistShopUpdateResponse> => {
  const { artistId, ...putParams } = params;
  return api.put(`/artists/${artistId}/shop`, {
    body: JSON.stringify(putParams),
  });
};

const useArtistShopAccessForm = (access?: PutArtistShopParams) => {
  const queryClient = useQueryClient();
  const form = useForm<PutArtistShopParams>({ defaultValues: access ?? {} });

  const mutation = useMutation(putArtistShop, {
    onSuccess: ({ shopConfig, artist }) => {
      queryClient.setQueryData(shopDataQueryKey, shopConfig);
      queryClient.setQueryData(artistKeys.detail(artist.id), artist);
    },
  });

  const resetForm = () => {
    form.reset();
    mutation.reset();
  };

  const onSubmit = form.handleSubmit((formData) => mutation.mutate(formData));

  return {
    ...form,
    onSubmit,
    mutation,
    resetForm,
  };
};

const useArtistShopUpdate = () => useMutation(putArtistShop);

export { useArtistShopUpdate, useArtistShopAccessForm };
